
import "../assets/style.css"
import 'bootstrap/dist/css/bootstrap.min.css';
import bangkok from '../../src/assets/bangkok.png'
import bangkok1 from '../../src/assets/bangkok1.jpg'
import { apiRequest } from '../ApiService/Allapi';
import React, { useState, useEffect } from 'react';
import Swal from "sweetalert2";


const AgentSection = () => {
    const [data, setdata] = useState([])

    const Fatchdata = async () => {

        let access_token = localStorage.getItem("token");
        const headers = {
            Authorization: `Bearer ${access_token}`,
        };

        try {
            const res = await apiRequest('about-us-data', "GET", null, headers)
            {
                console.log(res.data.architects?.designation)
            }
            if (res.success === true) {
                setdata(res.data);
            } else {

            }

        } catch (error) {
            Swal.fire({
                title: "Error",
                text: "Something went wrong while fetching data!",
                icon: "error",
            });
        }
    }
    useEffect(() => {
        Fatchdata();
    }, []);

    return (
        <>
            <div className="agent-page">
                <header className="agent-header">
                    <h1>Our Agents</h1>
                </header>

                <div className="agents-list">
                    {data?.agents?.map((agent, index) => (
                        <div key={index} className="agent-card">
                            <div className="agent-image-container">
                                <img

                                    src={agent?.image} style={{ width: '' }}
                                    alt={agent.name}
                                    className="agent-image"

                                />
                                {/* <div className="agent-badge">Agent #{index + 1}</div> */}
                            </div>

                            <div className="agent-details">
                                <h2 className="agent-name">{agent.name || "No Name Provided"}</h2>
                                {/* <p className="agent-title">Professional Real Estate Agent</p> */}

                                <div className="contact-info">
                                    <div className="contact-item">
                                        <span className="contact-icon">📱</span>
                                        <span>{agent.mobile || "Not Available"}</span>
                                    </div>
                                    <div className="contact-item">
                                        <span className="contact-icon">✉️</span>
                                        <span>{agent.email || "No Email Provided"}</span>
                                    </div>
                                </div>

                                {/* <button className="contact-button">Contact {agent.name?.split(' ')[0] || "Agent"}</button> */}
                            </div>
                        </div>
                    ))}
                </div>
            </div>

        </>
    );
}

export default AgentSection;